/* @flow */
import * as React from 'react';
import { graphql } from 'react-apollo';
import EventTracking from 'lib/EventTracking';
import MessageView from 'messages/components/MessageView';
import { EventTrackingConstants } from 'constants/EventTrackingConstants';
import GET_CHAT_STREAM_MESSAGE_ITEM from 'messages/queries/getChatMessageQuery.gql';

import type { GetChatStreamMessageItem } from 'messages/queries/__generated__/GetChatStreamMessageItem';

const isFooter = (source: string): boolean => {
  return source === 'footer';
};

type Props = {
  data: ReactApolloData<GetChatStreamMessageItem>,
  params: Object,
  location: Object,
};

class ChatMessageContainer extends React.Component<Props, void> {
  componentDidMount() {
    const { chatThreadUuid, chatMessageUuid } = this.props.params;
    const { _t: recipientUuid, src: source } = this.props.location.query;

    const contextName = isFooter(source)
      ? EventTrackingConstants.REACTION_LINK
      : EventTrackingConstants.ATTACHMENT_LINK;

    EventTracking.track('ui.tapped', {
      uuid: recipientUuid,
      ui_context: contextName,
      chat_uuid: chatThreadUuid,
      message_uuid: chatMessageUuid,
      screen_name: EventTrackingConstants.TEXT_MESSAGE,
    });
  }

  render() {
    const { _t: recipientUuid, token } = this.props.location.query;

    if (this.props.data.loading) {
      return <b>Loading message…</b>;
    }

    if (!this.props.data.chatStreamMessageItem) {
      return <b>Error loading message.</b>;
    }

    return (
      <MessageView
        token={token}
        recipientUuid={recipientUuid}
        message={this.props.data.chatStreamMessageItem}
      />
    );
  }
}

const withChatMessage = graphql(GET_CHAT_STREAM_MESSAGE_ITEM, {
  options: ownProps => {
    const { chatThreadUuid, chatMessageUuid } = ownProps.params;
    const { _t: recipientUuid, token } = ownProps.location.query;

    return {
      variables: {
        streamUuid: chatThreadUuid,
        itemUuid: chatMessageUuid,
        recipientUuid,
        token,
      },
    };
  },
});

export { ChatMessageContainer };
export default withChatMessage(ChatMessageContainer);
